/*
 *   File : radio-group.js
 *   Author URI : https://evoqins.com
 *   Description : Radio button component
 *   Integrations : NA
 *   Version : v1.1
 */


import React, { Component } from 'react';

//assets
import Select from "../../Assets/Images/Home/select.svg";
import Unselect from "../../Assets/Images/Home/unselect.svg";

function RadioGroup(props) {
    const { data, selectedItem, onSelectItem } = props;

    const handleRadioItemClick = (selected_id) => {
        onSelectItem(selected_id);
    };

    return (
        <div>
            {props.label &&
                <label className={`${props.labelStyle} e-primary-font e-text-rich-black e-font-weight-400 line-height-18px e-font-14 pb-3`}>
                    {props.label}
                    {props.require &&
                        <span className='e-text-lust'>*</span>
                    }
                </label>
            }
            <div className={`${props.className} d-flex align-items-center gap-4 flex-wrap pb-3`}>
                {
                    data.map((item, key) => (
                        <div
                            className='d-flex align-items-center e-radio cursor-pointer'
                            onClick={() => handleRadioItemClick(item.value)}
                            key={key}
                        >
                            <div className='text-start'>
                                <img
                                    width={16}
                                    height={16}
                                    draggable='false'
                                    src={selectedItem === item.value ? Select : Unselect}
                                    alt='radio-btn' />
                            </div>
                            <span className='e-radio-span e-primary-font e-font-12 e-font-weight-500 e-text-black ms-2 cursor-pointer pt-1'>{item.label}</span>
                        </div>
                    ))
                }
            </div>
        </div>

    );
}

export default RadioGroup;
